import { CategoryType, EquipmentType } from '../data/enums';
import { InspectionCategoryTypeModel, InspectionModel } from '../data/types';

export class InspectionModelHelpers {
  static isSynced(inspection: InspectionModel): boolean {
    return (
      inspection.isSynced &&
      inspection.inspectionCategoryTypes.every(
        (category) => category.isSynced,
      ) &&
      inspection.inspectionCategoryTypes.every((category) =>
        category.observations.every((observation) => observation.isSynced),
      )
    );
  }

  // Inspections synced without category types (e.g. shells persisted by a full
  // sync, see #10006) have no content to review or submit.
  static hasCategoryTypes(inspection: InspectionModel): boolean {
    return (inspection.inspectionCategoryTypes?.length ?? 0) > 0;
  }

  static formatInspectionCategoryTypeTitle(
    categoryTypes: InspectionCategoryTypeModel[],
  ): string {
    // category types included 'undercarriage' and 'condition' will be formatted string below
    if (
      categoryTypes.find(
        (c) =>
          (c.category.toLowerCase() ===
            EquipmentType.undercarriage.toLowerCase() ||
            c.category.toLowerCase() === EquipmentType.bucket.toLowerCase()) &&
          (c.type.toLowerCase() === CategoryType.condition.toLowerCase() ||
            c.type.toLowerCase() === CategoryType.changeout.toLowerCase()),
      ) !== undefined
    ) {
      return (
        'Condition & Changeout UC · Changeout UC/GET/BKT · ' +
        categoryTypes.map((c) => c.category).join(', ')
      );
    }

    return 'Condition UC · ' + categoryTypes.map((c) => c.category).join(', ');
  }
}
